import styled from 'styled-components/macro';

const ProfilePasswordContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 60rem;
`;

export default ProfilePasswordContent;
